import AssigneeEditor from "components/AssigneeEditor";
import { idPropType } from "constants/app";
import { ENTITY_TYPE_PATH } from "constants/entityTypes";
import {
  arrayOf,
  func,
  number,
  oneOf,
  oneOfType,
  shape,
  string,
} from "prop-types";

import classes from "./AssigneesCell.module.scss";

const assigneeShape = shape({
  workspaceUserId: idPropType.isRequired,
  userName: string,
  firstName: string,
  lastName: string,
});

const AssigneesCell = ({
  assignees = [],
  entityType,
  entityId,
  onAssigneesChange,
  onBeforeCommit,
}) => (
  <div
    className={classes.assignees_cell}
    onClick={(e) => e.stopPropagation()}
    onKeyDown={(e) => e.stopPropagation()}
  >
    <AssigneeEditor
      assignees={assignees}
      entityType={entityType}
      entityId={entityId}
      onAssigneesChange={onAssigneesChange}
      onBeforeCommit={onBeforeCommit}
    />
  </div>
);

AssigneesCell.propTypes = {
  assignees: arrayOf(assigneeShape),
  entityType: oneOf(Object.keys(ENTITY_TYPE_PATH)).isRequired,
  entityId: oneOfType([number, string]).isRequired,
  onAssigneesChange: func,
  onBeforeCommit: func,
};

export default AssigneesCell;
